<template>
  <div class="ino_mag page">
<div class='embed-container' data-page-width='495' data-page-height='640' id='ypembedcontainer' >
  <iframe   src="https://www.yumpu.com/en/embed/view/8mFj9zYNbqOcuDVo" frameborder="0" allowfullscreen="true"  allowtransparency="true"></iframe></div></div>
</template>
<script>

export default {
  data: () => ({
  }),
  mounted() {
    let iframemag = document.createElement('script')
    iframemag.setAttribute('src', 'https://players.yumpu.com/modules/embed/yp_r_iframe.js')
    document.head.appendChild(iframemag)
  }
}
</script>
<style>
.embed-container {
  position: relative;
  height:0;
  overflow: hidden;
  max-width: 100%; }
  .embed-container iframe, .embed-container object, .embed-container embed {
    top: 0;
    left: 0;
    margin:auto;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    width: 80%;
    height: 80%;}
    </style>



// WEBPACK FOOTER //
// src/components/InoMagazine.vue